import type { ReactNode } from 'react';

import type { Tab } from '../router';
import { TabBar } from './TabBar';
import { TopBar } from './TopBar';

/**
 * 骨架：**固定顶栏 + 可滚内容 + 固定底栏**。
 *
 * 三行网格（auto / 1fr / auto），壳本身正好一屏高，**在滚的只有中间那行**。
 * 两条不能改的性质都靠这个结构，不靠各自去算位置（见 app.css）：
 *
 *   上下两条栏不动   它们是网格的第一行和第三行，压根没参与滚动 ——
 *                    不是 sticky、也不是 fixed + 自己再算一遍居中
 *   溢出关在里面     .content 是滚动容器，哪一页横向溢出都只波及它自己，
 *                    不会把布局视口撑宽、把底栏挤出屏幕
 */
export function AppShell(
  { tab, onGo, session, nickname, onAuth, onSettings, children }:
  {
    tab: Tab;
    onGo(t: Tab): void;
    session: { uid: string } | null;
    nickname: string | null;
    onAuth(): void;
    onSettings(): void;
    children: ReactNode;
  },
) {
  return (
    <div className="app">
      <TopBar session={session} nickname={nickname} onAuth={onAuth} onSettings={onSettings} />
      {/* key=tab：切页时重挂内容，滚动位置自然回到顶部 */}
      <main className="content" key={tab}>{children}</main>
      <TabBar tab={tab} onGo={onGo} />
    </div>
  );
}
